import { darken } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { LFC } from '../../../Legacy';
import { Colors, Prompt } from '../../../ui';
import { Title } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';

const MessageFrame = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background: ${Colors.positive};
    cursor: pointer;
    user-select: none;

    &:hover {
        background: ${darken(.05, Colors.positive)};
    }
    &:active {
        background: ${darken(.1, Colors.positive)};
    }
`;

export const meetingFeedbackThanksPopup = () => ({ ui: MeetingFeedbackThanksPopup, fade: false });

export const MeetingFeedbackThanksPopup: LFC<PopupProps> = ({ dismiss, args }) => {

    return <Prompt onAction={dismiss}>
        <Popup w="20" p="0" shadow="lg" style={{ overflow: 'hidden' }}>
            <MessageFrame onClick={dismiss}>
                <Title flush size="3xl" color="white">Thank you!</Title>
            </MessageFrame>
        </Popup>
    </Prompt >;
};


